import api from "@/services/api.service";
import readXlsxFile from 'read-excel-file'
import {required} from 'vuelidate/lib/validators'

export default {
    name: 'edit',
    components: {readXlsxFile},
    props: {},
    data() {
        return {
            caption: "Edit Campaign",
            formField: {name: '', type: '', operator_id: '', tags: [], file: ''},
            submitStatus: null,
            showField:true,
            existing_tags:[],
            imageUrl: '',
            tags:[],
            removed_tags:[],
            permission_edit: false,
            superAdmin: false
        }
    },
    computed: {

    },
    watch:{
    },
    validations: {
        formField: {
            name: {
                required
            },
            type: {
                required
            },
            tags: {
                required
            }
        }
    },
    async created() {
        let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("edit_campaign") == true){
                this.getCampaign();   
                this.getTags();
                this.permission_edit = permissions.includes("edit_campaign");
            }else if(response.data[0].role == 'super_admin'){
                this.getCampaign();   
                this.getTags();
                this.superAdmin = true;
              }else if(permissions.includes("list_campaign") == true || permissions.includes("add_campaign") == true){
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'List Campaign'});
              }else{
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'Admin Dashboard'});
              }
          }
    },
    mounted() {

    },
    methods: {
        makeToast(message = '', title = 'Alert', variant = 'warning', time = '3000') {
            this.toastCount++
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: time
            })
        }, async getTags(){
            let response = await api.post("tags/list");
            if (!response)
                this.makeToast("Something went to wrong please try again","Alert","danger",6000);
            if (response.status == "success") {
                response.data.forEach(function(e){
                    this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
                }.bind(this));
            }            
       },
        async getCampaign() {
            let response = await api.post('campaign/list', {'id': this.$route.params.id});            
            if (!response)
                this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

            if (response.status == 'success') {
                if (response.data != '') {                    
                    this.formField = response.data

                    this.imageUrl = process.env.VUE_APP_IMAGE_URL + response.data.files[0].file_name;

                    response.data.tags.forEach( function(element) {
                        this.tags.push({'id':element.id,'value':element.tags});
                    }.bind(this));                                        
                    this.formField.tags = this.tags;             
                }
                else {
                    this.formField = [];
                    this.makeToast(`Campaign not found.`, 'Alert', 'danger')
                }
            } else {
                this.makeToast(response.msg || `Campaign not found.`, 'Alert', 'danger');
                this.$router.push({name:'List Campaign'});
            }
        },
        onTagRemoved(tag){
            this.removed_tags.push(tag.id);
        },
        async edit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
            } else {
                this.formField.id = this.$route.params.id;
                this.formField.removed_tags = this.removed_tags;
                
                let response = await api.post('admin/campaign/edit-campaign', this.formField);
                if (!response)
                    this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status == 'success') {
                    localStorage.removeItem('headers')
                    this.makeToast(response.message, 'Alert', 'success', 6000)
                    this.$router.push({'name': 'List Campaign'})
                } else {
                    for (var error in response.errors)
                        this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
                }
            }
        },
        onFileChanged(e) {
            let file = e.target.files[0];
            let reader = new FileReader();                            
            if (file.type == 'image/png' || file.type == 'image/jpeg') {
                 reader.onload = (e) => {                                    
                    this.formField.file = btoa(e.target.result);
                    };                            
            }else {
                this.makeToast("File must  be image", 'Alert', 'danger')
                return;
            }                        
            reader.readAsBinaryString(file)
        },
        back() {
            this.campaign_form = true;
            this.mapping_form = false;
        }
    }
}


